// extracted by mini-css-extract-plugin
export default {"poster":"uY54E","audio":"jIZwk","highlighted":"_3Segj"};